export default "__VITE_ASSET__CEnXYehP__"